import React from "react";
import styles from "./DataPointCard.module.scss";
import { Icon } from "../../atoms/Icon";
import { Button, Popover, Position } from "@blueprintjs/core";

function DataPointCard({ color = "", iconName, title, value, menu }) {
  return (
    <div className={styles.dataPointCard}>
      <div className={styles.icon}>
        <Icon size={62} color={color} name="Circle-Filled" />
        <Icon size={31} color="#fff" name={iconName} />
      </div>
      <div className={styles.content}>
        <span className={styles.dataPoint}>{value}</span>
        <span className={styles.dataPointTitle}>{title}</span>
      </div>
      {
        menu && (
          <div
            className={styles.menuIconWrapper}
          >
            <Popover
              position={Position.BOTTOM_LEFT}
            >
              <Button
                minimal
                icon={(
                  <Icon
                    name="Menu-Vertical"
                    className={styles.menuIcon}
                    color="#506883"
                  />
                )}
              />
              {menu}
            </Popover>
          </div>
        )
      }
    </div>
  );
}

export default DataPointCard;
